export default __webpack_public_path__ + "static/media/speaker_bg_helper.d95e3159.png";